export function formatJson(text: string): string {
  return `${JSON.stringify(JSON.parse(text), null, 2)}\n`;
}

export function formatXml(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(trimmed, 'application/xml');
  if (doc.querySelector('parsererror')) {
    throw new Error('Invalid XML.');
  }

  const serialized = new XMLSerializer().serializeToString(doc);
  const withBreaks = serialized.replace(/(>)(<)(\/*)/g, '$1\n$2$3');
  let pad = 0;
  const lines: string[] = [];

  for (const rawLine of withBreaks.split('\n')) {
    const line = rawLine.trim();
    if (!line) continue;
    if (/^<\//.test(line)) {
      pad = Math.max(pad - 1, 0);
    }
    lines.push(`${'  '.repeat(pad)}${line}`);
    if (/^<[^!?/][^>]*[^/]>$/.test(line)) {
      pad += 1;
    }
  }

  return `${lines.join('\n')}\n`;
}
